import directives from './module';
import {flickityLib, twitterWidgetLib} from '../lazy_modules';

class PressSwipable implements ng.IComponentController {
    readonly flicktyPromise: ng.IPromise<any>;

    constructor(protected $element: ng.IAugmentedJQuery,
                protected $q: ng.IQService) {
        this.flicktyPromise = $q(resolve => loadScripts([flickityLib], resolve));
    }

    $postLink() {
        this.initFlickty('.slide', false, true);
    }

    protected initFlickty(cellSelector: string, prevNextButtons: boolean, pageDots: boolean) {
        this.flicktyPromise.then(() => {
            const Flickity = window.Flickity;
            new Flickity(this.$element[0].firstChild, {
                cellSelector,
                prevNextButtons,
                pageDots,
                wrapAround: true,
                resize: false,
                cellAlign: 'center',
                adaptiveHeight: true,
                setGallerySize: false
            });
        });
    }
}

class PressSwipableTwitter extends PressSwipable {
    readonly twitterPromise: ng.IPromise<any>;

    constructor(protected $element: ng.IAugmentedJQuery,
                protected $q: ng.IQService) {
        super($element, $q);
        this.twitterPromise = $q(resolve => loadScripts([twitterWidgetLib], resolve));
    }

    $postLink() {
        const children = this.$element[0].firstElementChild.childElementCount;
        let rendered   = 0;
        this.twitterPromise.then(() => window.twttr.events.bind('rendered', () => {
                if (++rendered === children) {
                    this.initFlickty('.twitter-tweet', true, true);
                }
            }
        ));
    }
}

directives.component('pressSwipable', {
    controller: PressSwipable,
    templateUrl: require('press-swipable.html')
});

directives.component('pressTwitterGallery', {
    controller: PressSwipableTwitter,
    templateUrl: require('press-twitter-gallery.html')
});



// WEBPACK FOOTER //
// ./app/assets/javascripts/directives/PressSwipable.ts